import { QuoteFromPageSourceEnum } from '@jove-frontend/enums';

export const useChannelSource = () => {
  /**
   * methods
   */
  const isGreatAmericanChannel = () => {
    return (
      window.location.hostname.indexOf('.ga.') !== -1 ||
      sessionStorage.getItem('channel-ga') === 'true'
    );
  };
  const isNewGoodsInTransitChannel = () => {
    return (
      window.location.hostname.indexOf('.git.') !== -1 ||
      sessionStorage.getItem('channel-git') === 'true'
    );
  };
  const isChubbChannel = () => {
    return !(isGreatAmericanChannel() || isNewGoodsInTransitChannel());
  };

  const isMspChannel = () => {
    return (
      window.location.href.indexOf(
        `quoteSourceChannel=${QuoteFromPageSourceEnum.msp}`
      ) !== -1
    );
  };

  return {
    isChubbChannel,
    isGreatAmericanChannel,
    isNewGoodsInTransitChannel,
    isMspChannel,
  };
};
